<template>
  <div
    :class="`access-event-tile__container${isDeleting ? '_deleting' : ''}`"
    :style="`${removed ? 'display: none;' : ''}`"
    @click="$emit('click')"
  >
    <img
      v-lazy="detection.imageUrl"
      class="access-event-tile__image"
    >
    <div
      class="access-event-tile__button"
      @click="handleRemoveFaceRequest"
    >
      Remove Detection
    </div>
  </div>
</template>

<script>
import { rejectConfirmedTags } from '@/libraries/api/credentialMismatch'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AccessEventDetectionTile',
  props: {
    detection: {
      type: Object,
    },
  },
  data () {
    return {
      isDeleting: false,
      removed: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedProfile: 'credentialMismatch/selectedProfile',
      currentDomainUUID: 'currentDomainUUID',
    }),
  },
  methods: {
    ...mapActions({
      loadVerifiedMatchesForIdentityId: 'credentialMismatch/loadVerifiedMatchesForIdentityId',
    }),
    handleRemoveFaceRequest () {
      this.isDeleting = true
      const deletedTag = [{
        access_event_uuid: this.detection.eventId,
        detection_id: this.detection.detectionId,
        identity_id: this.detection.confirmedIds,
        rejected_for: 'WRONG_PERSON',
      }]
      rejectConfirmedTags(deletedTag, this.currentDomainUUID)
        .then(res => res.data)
        .then(function (data) {
          if (data.ok) {
            this.removed = true
            this.loadVerifiedMatchesForIdentityId(this.selectedProfile.identityId)
          }
        }.bind(this))
        .catch(error => {
          console.error('AccessEventDetectionTile: ', error)
        })
    },
  },
}
</script>

<style scoped>
.access-event-tile__container,
.access-event-tile__container_deleting {
  display: flex;
  flex-direction: column;
  height: 14rem;
  width: 12.5rem;
  margin: 0.5rem;
  width: fit-content;
  border-radius: 0.35rem;
  overflow: hidden;
  transition: all 200ms linear;
}

.access-event-tile__container_deleting {
  opacity: 0.5;
  transform: scale(0.8);
}

.access-event-tile__image {
  width: 11rem;
  height: 11rem;
  object-fit: cover;
  /* border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem; */
  border-radius: 0.35rem;
  border: 1px solid #8492a6;
}

.access-event-tile__button {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #d0021b;
  color: #fff;
  font-family: Lato-Bold;
  height: 3rem;
  z-index: inherit;
  border-bottom-left-radius: 0.35rem;
  border-bottom-right-radius: 0.35rem;
  border: 1px solid #8492a6;
  box-shadow: 0 0 1.25rem 0 rgba(132, 146, 166, 0.15);
  transition: all 200ms linear;
  filter: initial;
}

.access-event-tile__button:hover {
  filter: brightness(1.1);
}
</style>
